import { render, staticRenderFns } from "./OptionalTableColumn.vue?vue&type=template&id=24edb5c2&scoped=true&"
import script from "./OptionalTableColumn.vue?vue&type=script&lang=js&"
export * from "./OptionalTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./OptionalTableColumn.vue?vue&type=style&index=0&id=24edb5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24edb5c2",
  null
  
)

export default component.exports